import React, { useState } from "react";
import { colorPreviewUrl } from "@/lib/api";

export const BeforeAfter = ({ mediaId, version }) => {
  const [pos, setPos] = useState(50);
  if (!mediaId) return <div className="studio-card p-8 text-center text-[#64748B] text-sm">Import clips with proxies to preview the grade.</div>;
  return (
    <div className="studio-card p-3" data-testid="color-before-after">
      <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-black select-none">
        <img src={colorPreviewUrl(mediaId, false, version)} alt="before" className="absolute inset-0 w-full h-full object-contain" data-testid="color-preview-before" />
        <div className="absolute inset-0 overflow-hidden" style={{ clipPath: `inset(0 0 0 ${pos}%)` }}>
          <img src={colorPreviewUrl(mediaId, true, version)} alt="after" className="absolute inset-0 w-full h-full object-contain" data-testid="color-preview-after" />
        </div>
        <div className="absolute top-0 bottom-0 w-px bg-[#E6B04E]" style={{ left: `${pos}%` }} />
        <span className="absolute top-2 left-2 chip bg-black/60 text-white">BEFORE</span>
        <span className="absolute top-2 right-2 chip bg-[#E6B04E] text-[#1a1405]">GRADED</span>
      </div>
      <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(+e.target.value)}
        className="w-full mt-2 accent-[#E6B04E]" data-testid="color-compare-slider" />
    </div>
  );
};
